// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"4a4384ad","78":"b127f759","159":"7118db38","162":"2b099689","165":"74439271","221":"eb26ef92","319":"63989bb4","386":"c8961571","429":"a1d660cf","488":"52454dd7","493":"eadbe480","545":"3f80969a","682":"d03260ee","928":"4e21ec6d","984":"55da19e0"}[chunkId] + ".chunk.js";
};